import { AppInfo } from "@mitel/cloudlink-sdk";
import { LogLevel } from "src/app/modules/meet-logger/services/logging/log-level.enum";
import { version } from './version';

export const environment = {
	production: true,
	cloud: 'public',
	logLevel: LogLevel.Info,
	maxLogs: 1000,
	clientId: 'b3359f38354b4e0091e18d8071266aae',
	supportPortalClientId: '1812c35fe5b34f1b95c71c2e14455b43',
	featureFlagsClientId: 'c2dfc56e6dc84fb7832a190c163fb59b',
	systemPolicyId: 'system-policy',
	appInfo: new AppInfo({
		correlationIdPrefix: 'cl-accounts-web',
		app: {
		  name: 'cl-accounts-web',
		  version: version.appVersion,
		},
		enableAppHeader: true,
	  }),
	googleApiKey: 'AIzaSyAQW4GVQUPvQXB3QmqF9OFfOJlnWzs__GQ',
  adminURL: 'https://admin.api.mitel.io/2017-09-01',
	authURL: 'https://auth.mitel.io/',
	statusURL: 'https://status.mitel.io/',
	directorUrl: 'https://director.api.mitel.io/2018-07-01',
	mivbProvisioningUrl: 'https://mivb.provisioning.api.mitel.io/2017-09-01',
	tunnelUrl: 'https://tunnel.api.mitel.io',
	tunnelUrlWithVersion: 'https://tunnel.api.mitel.io/2017-09-01',
	billingUrl: 'https://billing.api.mitel.io/2019-03-01', // HACK: Temporary for use in UserTemplatesService until we upgrade @mitel/cloudlink SDK to ^1.0.0
	billingSpa: {
		ordersURL: 'https://billing.mitel.io',
	   	clientId: '5d3300d7978748ecbfc590166d37197b'
	},
	developerSpa: { // still need the details
		developerURL: 'https://developerapis.mitel.io',
	   clientId: '2d1612af1b7f4e0fbbe5549530713973'
   	},
	gatewayPortalSpa: {
		gatewayPortalUrl: "https://gateway.mitel.io",
		clientId: '42ade67aa234419486d611fd6825a913'
	},
	callCenterSpa: {
		callCentreStageDevBaseURL: 'https://cc-admin.mitel.io',
		callCentreBaseURL: 'https://cc-admin.mitel.io',
		free_ccnextProductRatePlanId: "2c92a0fd781c74ba01783d2d21b632a8",
		free_ccnextProductRatePlanChargeId: "2c92a00e781c672c01783d3199417212",
		clientId:"69ae27c0e7924d3fe78c3caa864e76ad"
	},
	workflowSpa: {
		workFlowUrl: 'https://workflow.dev.mitel.io',
		clientId:"a2962e7e4fa5cfc485e817c9d8241a8f"
	},
	supportLogsSpa: {
		logsUrl: 'https://supportlogs.mitel.io',
		clientId: 'bdc8a76cda334e57ae528bd483387e0b'
	},
	rolesSpa: {
		rolesUrl: 'https://rbac.mitel.io',
		clientId: 'f21e604ef1b74bb981d7b9264761f4d5'
	},
	miAccessBaseUrl: 'https://miaccess.mitel.com/connect/rest/',
	miAccessToken: "S]0c=T[tz9a*b'czJCDhesk3S]Qfa({-9YPy2c'Sg?rwGW>B>h&5oaN?}5=LBVdR",
	free_productRatePlanId: "2c92a00870a43ea90170b1baad531ea2",
	free_productRatePlanChargeId: "2c92a00870a43ea90170b1baad781ead",
	office365ClientId: "15949bef-c089-463f-b794-cb1c12f7444d",
	subscriptionIds:
	{
		MiTeam: ["2c92a00e6dd988dc016df8f375e81113"],
		ContactCenter: ["2c92a011781c74d001783d2619e7399d"],
		MitelOne: ["2c92a00d7aed8d2f017af485b2a35e73", "2c92a0087982e83c017984a4dc67425c"],
		MiVoice5000: ["8a129f6f806f95e80180735b7d3e428b"],
		MiVoiceBusiness: ['8ad08c0f7cc21783017cc2c66e165b1e', '8ad094b9858682c401859c029bf93a00'],
		WorkflowStudio: ['8a12959d97a206d00197ae05297f1f51'],
		ZoomHybrid: ['8a12826b953c713901954967ee244030', '8a1280be953c713f01954d3a113a79f9'] // ZoomHybrid and ZoomHybridIndirect
	},
	workflowStudioClientId: 'a2962e7e4fa5cfc485e817c9d8241a8f',

	//MiVB Hybrid Apps. No public details available yet.
	ACDSpa: {
		ACDUrl: '',
		clientId: ''
	},
	autoAttendantSpa: {
		autoAttendantUrl: '',
		clientId: ''
	},
	callFlowsSpa: {
		callFlowsUrl: '',
		clientId: ''
	},
	callReroutingsSpa: {
		callReroutingsUrl: '',
		clientId: ''
	},
	groupsSpa: {
		groupsUrl: '',
		clientId: ''
	},
	phoneKeyTemplateSpa: {
		phoneKeyTemplateUrl: '',
		clientId: ''
	},
	musicOnHoldSpa: {
		musicOnHoldUrl: '',
		clientId: ''
	},
	speedDialSpa: {
		speedDialUrl: '',
		clientId: ''
	},
	templateManagementSpa: {
		templateManagementUrl: 'https://usertemplates.mitel.io',
		clientId: '7059d8de1ef34345b90d7955e1888148'
	},
	mivbsettingsSpa: {
		mivbsettingsUrl: 'https://mivbsettings.mitel.io'
//		mivbsettingsUrl: 'http://dev-mivbsettings.mitel-dev.io:4600',
	},
  systemInventorySpa: {
    systemInventoryUrl: 'https://systeminventory.mitel.io',
    clientId: '31c564ed135a4712b775bf2be4991031'
  },
	importUserTemplatesActivityId: 'global_2d0d8f59-625b-4619-9fd7-9d45603da326',
	msteams: {
		certificate: "MIICezCCAWOgAwIBAgIBATANBgkqhkiG9w0BAQUFADAAMCAXDTI0MDUwODA3MTU0OFoYDzIxMjQwNTA4MDcxNTQ4WjAAMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1EsA0MC+nIw4gsDA3AWaTAG+Q7Q9A33xYQJuzFxiijmvm1nvWlKF2j5Z68ipXmL4MafcrdEIPEf5kfe6RB+FKRjLXDvCnhRWQn4YVK3yhXFZcuVyw41afBLiLmkbryRvswWT9xmiInvXQs1TSgoMIZDpKNJDin0yKj0gQLyh/kqTj2DZj7lKunShnD40agQosXAHkbqOfj4rfuFls7aEPKxFmlRS1abh0UDHiw5IuhnexDZKh4nBuvMNWr9B7P69daWzJNleEoMheBmls3Fi/xIqEknTXfmXzuuGLl16JLmjqc+txzMaZSHoopuPXcBLP642oSyFh4pkrvtOGrj3lQIDAQABMA0GCSqGSIb3DQEBBQUAA4IBAQBBNavl6WOSq6VOIY6aMlqbmFb89FRjUzmty4DegipzkyAyWd0CqJ9dEncQsqIWZOfy0pXTUDC2MPCjZ/w8ETyANxTOR7QrlVsWciHPmyxPbqEzGd2RKp0+oaW8DDTqlyigj8xH9jeCn3gQ79BrjC9QORKlenaTRwxHH2oBivOl/W4hyvzGzZZZcbIr1JWYjLvTQUqmO8WXeG3tOGgPJ+GbOi5aHLITIQauZ8xYjxrDDyBguqxnggR+DOtwoD9oNVUbwMaaNwIO7q8l6d2y/hIk78hW0rKDNdJMav5oAhQ6/lzmqCCSmoCBORLpmxMTQWsV8gPe7Nfx2Voct+M62kHJ",
		privateKey: "-----BEGIN RSA PRIVATE KEY-----\nMIIEowIBAAKCAQEA1EsA0MC+nIw4gsDA3AWaTAG+Q7Q9A33xYQJuzFxiijmvm1nv\nWlKF2j5Z68ipXmL4MafcrdEIPEf5kfe6RB+FKRjLXDvCnhRWQn4YVK3yhXFZcuVy\nw41afBLiLmkbryRvswWT9xmiInvXQs1TSgoMIZDpKNJDin0yKj0gQLyh/kqTj2DZ\nj7lKunShnD40agQosXAHkbqOfj4rfuFls7aEPKxFmlRS1abh0UDHiw5IuhnexDZK\nh4nBuvMNWr9B7P69daWzJNleEoMheBmls3Fi/xIqEknTXfmXzuuGLl16JLmjqc+t\nxzMaZSHoopuPXcBLP642oSyFh4pkrvtOGrj3lQIDAQABAoIBACIU4yNLDk7g+WGP\nGGc6RF8swyLow12AJp7wXmFTTkPqpuqbMaCf3FABRTu5PJej7pHqOl9yo45/RO3O\nMN/RlPXYE9h8L5kOosU3Vn33FGxKmkBRMxokjgDv9yfZmqbaLqSK91+VhJYMqQOs\nevvz86af4Q67UuSKMjeIa1kj73h8rah6LNPdnf+pqGQ5T1cvUYtr+cMVmG33p2ah\nZjqNsMtgeQs2rbl+5n7vCO1ENnXmIPanvB11si2+5zeNJugRgFLyuF8ugmVpO9oc\nATe53Otlsa7/NZ+OEqW2+309W0T8ty3YYMIKN5ky9tYT5VEvSnxpNUzWL2qe8qDp\nJ1slYjECgYEA5JFhhWnxKLQHMwa2w9UYgYdtuZ//xE6AAIFjOXGgBCO0wHC5cEyx\nGVJwZBlNosOP93hlV78nO4G6KmGEpl3qZLNPSGXUdTr2reGg4KgXjsA82QlvmDTN\nU4cBPO28L2X3F0den1ofziLDMBSlT1yaduWC2P+uEJm+p4tDY5hLRnMCgYEA7cWV\nsrs3ElteeZGP6vDk0omL1HB2vP5ESEtue4Ph3ONfz5/lOBzhaOizMavDejZWembS\ny4gCHYv0muzLbxVpdwyORCilKsxuFmXYOwKU25yPP3d1QaWYcJHHSMr5hZpT8xDs\n9DgOv6Mlp4/f2OjuZOOBAOTrx7vXrfXJKzELv9cCgYAe++YwY7AhSGZBcIOOAHEV\n/fnN0/aj8dBAQUnmG5UJep2iCKXap0rKl/ZMW3G+wqvdbCCwyGTVGDzYSefldY20\noOn6cnNegOO3poJccezfmQemlDTgeSfsTrzIOaHs+vGH4lDdYSY2l1fGSMYv/+mg\nfHREXkSGU5EYvTQhaB+sKQKBgQCqEoNSNcFdmwdHk4vKtAYoZgQjr1HvOzxiLbpY\nFOxQkD6vByLw8Q92d8P9CmwnFYjjwnqS5LUGp14OFsQor7shUVTNgfkqVNGFqdFx\n3BXXw/NepTa0/xq7ojpWYgD6xHm5yeiDgzlhb/P2F944i9xBQ825cwUHd9/86Wq8\nPze1PwKBgBFNI8/JZT5H/A3Vzc/dxgIayDctsZGiPab5Hv0CFkbzZEgs0KDl+6/e\nchMlMINoLBSA1KZQSVPgAk0QKvltR3OtRsFsmYadW9EQPa4e7HGAFNFiJrXDrm9a\nB4tH4g0hZoCs6C8PoPnG8mgMeWYKkGhG0UY0MN/AgfX8HMoLflku\n-----END RSA PRIVATE KEY-----\n"
	},
	systemManagerUrl: 'https://system-manager.api.mitel.io/2023-07-01',
	proximusPartnerId: '463257461',
	workflowUrl: 'https://workflow.api.mitel.io/2017-09-01',
	manageSIPTrunksActivityId: 'global_d19221b4-1631-4c46-9cc5-8818baddc688'
};
